import { Controller } from "@hotwired/stimulus"

// TASK-494: local two-step removal disclosure inside one native feature dialog.
// Server commands remain authoritative; this controller only swaps same-size action banks.
export default class extends Controller {
  static targets = ["management", "removal", "removeTrigger", "cancel"]

  connect() {
    this.reset()
  }

  confirmRemove(event) {
    event.preventDefault()
    this.showRemoval(true, this.cancelTarget)
  }

  cancelRemove(event) {
    event.preventDefault()
    this.showRemoval(false, this.removeTriggerTarget)
  }

  reset() {
    this.showRemoval(false)
  }

  showRemoval(removing, focusTarget = null) {
    if (!this.hasManagementTarget || !this.hasRemovalTarget) return

    this.managementTarget.hidden = removing
    this.managementTarget.inert = removing
    this.removalTarget.hidden = !removing
    this.removalTarget.inert = !removing
    if (focusTarget) requestAnimationFrame(() => focusTarget.focus())
  }
}
